import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Background from '../../components/Background/Background'
import FlexSection from '../../components/FlexSection/FlexSection'
import CustomSlider from '../../components/CustomSlider/CustomSlider'
import Title from '../../components/Title/Title'
import SelectedSex from '../../components/SelectedSex/SelectedSex'
import Glass from './Glass'

const CURRENT_STEP_NUMBER = 5
const NEXT_STEP_URL = 'bruker-bleie'

class Age extends Component {
  constructor (props) {
    super(props)
    this.state = {
      amount: 50
    }
    this.onSliderChange = this.onSliderChange.bind(this)
    this.onAfterSliderChange = this.onAfterSliderChange.bind(this)
  }

  componentDidMount () {
    this.props.initStep(CURRENT_STEP_NUMBER, NEXT_STEP_URL)
  }

  onSliderChange (value) {
    this.setState({ amount: value })
  }

  onAfterSliderChange (value, id) {
    const answerString = this.formatAmountText(this.state.amount)
    this.props.updateScore(value / 100, id, CURRENT_STEP_NUMBER, answerString)
  }

  formatAmountText = amount =>
    amount / 100 < 0.5
      ? 'Litt'
      : amount / 100 >= 0.5 && amount / 100 < 0.9 ? 'Mye' : 'Veldig mye'

  render () {
    const { selectedSex } = this.props
    const { amount } = this.state

    return (
      <Background color="#FFB297">
        <FlexSection>
          <Title>
            Hvor mye tisser <SelectedSex selectedSex={selectedSex} /> på seg i løpet av
            natten?
          </Title>
          <div>
            <Glass amount={amount} />
            <div className="white primary-font-bold mt2 f2">
              {this.formatAmountText(this.state.amount)}
            </div>
          </div>
          {/* <Image dynamic {...images} selectedSex={selectedSex} age={age} /> */}
          <div className="flex justify-between ph4 mw7 w-100 mt2 mb1">
            <CustomSlider
              onSliderChange={this.onSliderChange}
              onAfterSliderChange={this.onAfterSliderChange}
              id={1}
              min={0}
              max={100}
              defaultValue={amount}
            />
          </div>
        </FlexSection>
      </Background>
    )
  }
}

Age.propTypes = {
  updateScore: PropTypes.func.isRequired,
  selectedSex: PropTypes.string
}

export default Age



// WEBPACK FOOTER //
// ./src/containers/Amount/Amount.js